export default __webpack_public_path__ + "static/media/double-arrow-left.620d0917.svg";